export const STAKING_RISK_CHART_STATISTIC_SUCCESS =
  "STAKING_RISK_CHART_STATISTIC_SUCCESS";

const stakingRiskStatisticState = {
  stakingRiskStatisticResult: [],
};

export function StakingRiskChartStatisticReducer(
  state = stakingRiskStatisticState,
  action
) {
  if (action.type === STAKING_RISK_CHART_STATISTIC_SUCCESS) {
    return {
      ...stakingRiskStatisticState,
      stakingRiskStatisticResult: action.payload.result,
    };
  }

  return state;
}
